import { render, staticRenderFns } from "./not-authenticated.vue?vue&type=template&id=5ba0debb&"
import script from "./not-authenticated.vue?vue&type=script&lang=js&"
export * from "./not-authenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports